import React, { useEffect, useState } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ClockIcon } from 'lucide-react';
export function LimitedTimeDeals() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 5,
    minutes: 30,
    seconds: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(previousTime => {
        if (previousTime.seconds > 0) {
          return {
            ...previousTime,
            seconds: previousTime.seconds - 1
          };
        }
        if (previousTime.minutes > 0) {
          return {
            hours: previousTime.hours,
            minutes: previousTime.minutes - 1,
            seconds: 59
          };
        }
        if (previousTime.hours > 0) {
          return {
            hours: previousTime.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return previousTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Premium Whey Protein Isolate',
    brand: 'Optimum Nutrition',
    price: 89.99,
    originalPrice: 149.99,
    discount: 40,
    rating: 4.8,
    reviewCount: 324,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isBestSeller: true,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Multivitamin Complex Plus',
    brand: 'Centrum',
    price: 34.99,
    originalPrice: 59.99,
    discount: 42,
    rating: 4.7,
    reviewCount: 256,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
    expressDelivery: true
  }, {
    id: 3,
    name: 'Pre-Workout Energy Boost',
    brand: 'C4',
    price: 44.99,
    originalPrice: 79.99,
    discount: 44,
    rating: 4.6,
    reviewCount: 189,
    image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
    expressDelivery: true
  }, {
    id: 4,
    name: 'Omega-3 Fish Oil 1000mg',
    brand: 'Nature Made',
    price: 29.99,
    originalPrice: 49.99,
    discount: 40,
    rating: 4.5,
    reviewCount: 145,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
    isNew: true,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Vitamin C 1000mg Tablets',
    brand: 'Solgar',
    price: 22.99,
    originalPrice: 37.99,
    discount: 39,
    rating: 4.7,
    reviewCount: 208,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
    expressDelivery: true
  }, {
    id: 6,
    name: 'Daily Probiotic Capsules',
    brand: 'Culturelle',
    price: 39.99,
    originalPrice: 64.99,
    discount: 38,
    rating: 4.8,
    reviewCount: 176,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    expressDelivery: true
  }];
  return <section className="container mx-auto px-4" aria-labelledby="limited-time-deals-title" data-id="element-4303" data-mp="3cxd95yebgskp">
      <div className="overflow-hidden rounded-xl border border-[#DCE9DE] bg-white" data-id="element-4304" data-mp="3lf5pa56htnu0">
        <header className="flex flex-col gap-3 bg-pharmacy px-4 py-4 text-white md:flex-row md:items-center md:justify-between md:px-6" data-id="element-4305" data-mp="3phikw0rj05d2">
          <div className="flex items-center gap-3" data-id="element-4306" data-mp="3bismmhsyzzn4">
            <ClockIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-4307" data-mp="3gg2j2hes1bkg" />
            <div data-id="element-4308" data-mp="3gi5lk0x48x62">
              <h2 id="limited-time-deals-title" className="text-xl font-bold md:text-2xl" data-id="element-4309" data-mp="80r9pu8nbyq3">Limited Time Deals</h2>
              <p className="text-sm text-white/80" data-id="element-4310" data-mp="d03tu784uroz">Save before these offers end</p>
            </div>
          </div>
          <div className="flex items-center self-start rounded-lg border border-white/25 bg-white/15 px-3 py-2 font-bold tabular-nums md:self-auto" data-id="element-4311" data-mp="3uf2a1vpri2js">
            <span className="sr-only" data-id="element-4312" data-mp="37g05lcg93uh">Time remaining: </span>
            {String(timeLeft.hours).padStart(2, '0')} : {String(timeLeft.minutes).padStart(2, '0')} : {String(timeLeft.seconds).padStart(2, '0')}
          </div>
        </header>

        <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 py-4 scrollbar-hide md:grid md:grid-cols-3 md:gap-4 md:overflow-visible md:px-6 md:py-6 lg:grid-cols-6" data-id="element-4313" data-mp="339wyk0sc8upp">
          {products.map(product => <div key={product.id} className="w-[42vw] max-w-[200px] shrink-0 snap-start md:w-auto md:max-w-none" data-id="element-4314" data-mp="2u9rr5qn59wbj">
              <EnhancedProductCard product={product} data-id="element-4315" data-mp="2pbq835ppxx02" />
            </div>)}
        </div>
      </div>
    </section>;
}